import { useSWRHandler } from "./useSWRHandler"
import { usePumpStatuses } from "src/hooks"

export function usePumpStatusHandler() {
  return useSWRHandler(usePumpStatuses)
}
